import React, { useState, useEffect, useContext, createContext } from 'react';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Button } from 'antd';

import toast from 'react-hot-toast';
import KeyPad from '../../../components/keyPad/keyPad';

export const selectedMissionContext = createContext();
    
function TotalPriceModal(props) {

  const { showModal, toggleModal, title, table, selectedTab, subTotal, totalVatAmount, data } = props;
  const { tabData, setTabData, setJournalVoucher } = useContext(PosCartContext);

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const { settingData } = useContext(DataContext);


  const cart = tabData[selectedTab].cart;
  const journalVoucher = tabData[selectedTab].journalVoucher;

  useEffect(() => {
    setInputValue("");
  }, [showModal]);


  const handleSubmit = () => {

    const discountPercentage = ((1 - (inputValue-totalVatAmount) / subTotal) * 100);

    
    let updatedJv = { ...journalVoucher };
    updatedJv.discountPercentage = discountPercentage;

    setJournalVoucher(updatedJv, selectedTab);
    toggleModal();
  }

  return (
    <Modal show={showModal} onHide={toggleModal} className='Delete_modal'>
      <Modal.Header style={{ background: "#1d7790" }}>
        <Modal.Title className="arabicText" style={{ color: "white" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="arabicText">

        <Row className="mb-4">
          <Col>
            <Form.Control type='number' value={inputValue}
              onChange={e => setInputValue(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') { handleSubmit() } }}
              autoFocus />
          </Col>
        </Row>

        <Row>
          <Col md={2}>
          </Col>
          <Col md={8}>
            <KeyPad
              setInputValue={setInputValue}
              inputValue={inputValue}
            />
          </Col>
          <Col md={2}>
          </Col>
        </Row>

      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button type="primary" size="large" loading={loadingEffect} onClick={handleSubmit}
            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }} danger>Done</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default TotalPriceModal;
